ApiError = require 'network/api-error'
Payloads = require 'network/payloads'
EnterpriseAdminDashboardView = undefined
queueRequire -> EnterpriseAdminDashboardView = require 'views/enterprise/enterprise-admin-dashboard-view'
Enterprise = undefined
queueRequire -> Enterprise = require 'models/enterprise'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
log = require 'debug/log'
Promise = require 'bluebird'
$ = require 'jquery'

module.exports =
  routes: [
    ['e/:name/admin', 'enterpriseAdminDashboardView']
    ['e/:name/admin/:tab', 'enterpriseDashTab']
  ]

  displayEnterprisePage: (settings) ->
    { enterpriseName, viewClass, tab } = settings

    log('controller', ['enterprise'])

    isCachedModelValidPredicates = [
      (enterprise) -> enterprise.get('idOrganizations')?.length == enterprise.organizationList.length
    ]

    Promise.using @getSpinner(), =>
      Enterprise.load enterpriseName, Payloads.enterprise, ModelCache, isCachedModelValidPredicates
      .then (enterprise) =>
        if !enterprise.isRealEnterprise()
          @displayErrorPage()
          return

        @clearPreviousView()
        @setViewType(enterprise)

        options = { modelCache: ModelCache, initialTab: tab }
        enterpriseView = @topLevelView(viewClass, enterprise, options)
        @showHeader()

        $('body').addClass('body-tabbed-page')
        $('#content').html(enterpriseView.render().el)

        title = enterprise.get('displayName')

        @setLocation
          title: title
          location: settings.getLocation.call(@, enterprise.get('name'), tab)

        return
      .catch ApiError, =>
        @displayErrorPage()
        return

  enterpriseAdminDashboardView: (enterpriseName) ->
    @displayEnterprisePage
      enterpriseName: enterpriseName
      viewClass: EnterpriseAdminDashboardView
      getLocation: @getEnterpriseAdminDashboardUrl
    .done()

  enterpriseDashTab: (enterpriseName, tab) ->
    if tab != 'members' && tab != 'teams'
        @displayErrorPage()
        return

    @displayEnterprisePage
      enterpriseName: enterpriseName
      viewClass: EnterpriseAdminDashboardView
      getLocation: @getEnterpriseAdminDashboardUrl
      tab: tab
    .done()



// WEBPACK FOOTER //
// ./app/scripts/controller/enterprise-routes.coffee